import SlWholesaleDiscountFamily from '@/models/Sale/SlWholesaleDiscountFamily'
import WhFamily from '@/models/Warehouse/WhFamily'
import axios from 'axios'
import API from '@/services/api/api'
// import axios from 'axios'
// import API from '@/services/api/api'

const fetchWholesaleDiscountsFamily = async function(id) {
    try {
        let discountsFamily =  await SlWholesaleDiscountFamily.where('g_branch_office_id', 1)
        .where('wh_family_id', id)
        .params({'get_all_results':true })
        .get()
        return discountsFamily.data
    } catch (error) {
        return error
    }
}

const createWholeSaleDiscounts = async function(arrayDiscounts, id) {
    try {
        let discountSchema = []
        for (let i = 0; i < arrayDiscounts.length; i++) {
            let currentDiscount = {
                    quantity_discount: parseInt(arrayDiscounts[i].quantity),
                    percentage_discount: parseInt(arrayDiscounts[i].discount),
                    unit_price_discount: 0,
                }

            discountSchema.push(currentDiscount)
        }

        let data = {
            wh_family_id: id,
            g_branch_office_id: 1,
            discount_schema: discountSchema,
        }
        
        let wh = new SlWholesaleDiscountFamily(data)
        let response = await wh.save()

        return response
    } catch (error) {
        //return error.response.data
        return error
    }
}

const updateWholesaleDiscounts = async function(arrayDiscounts, id) {
    let discountSchema = []
    for (let i = 0; i < arrayDiscounts.length; i++) {
        let currentDiscount = {
                quantity_discount: parseInt(arrayDiscounts[i].quantity),
                percentage_discount: parseInt(arrayDiscounts[i].discount),
                unit_price_discount: 0,
            }

        discountSchema.push(currentDiscount)
    }


    let data = {
        g_branch_office_id: 1, // id sucursal TODO: quitar hard code
        discount_schema: discountSchema,
    }

    try{
        let response = await axios.put(`${API.SL_WHOLESALE_DISCOUNT_FAMILY}/${id}`, data)
        return response.data
    }catch(error){
        return(error)
    }

}


const deleteWholesaleDiscounts = async function(id) {

    let data = {
        g_branch_office_id: 1, // id sucursal TODO: quitar hard code
        discount_schema: [],
    }

    try{
        let response = await axios.put(`${API.SL_WHOLESALE_DISCOUNT_FAMILY}/${id}`, data)
        return response.data
    }catch(error){
        return(error)
    }


}

export default {
    fetchWholesaleDiscountsFamily,
    createWholeSaleDiscounts,
    updateWholesaleDiscounts,
    deleteWholesaleDiscounts,
}